import { render, staticRenderFns } from "./settings-organization-spam.vue?vue&type=template&id=11763ccb&scoped=true&"
import script from "./settings-organization-spam.vue?vue&type=script&lang=js&"
export * from "./settings-organization-spam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11763ccb",
  null
  
)

export default component.exports